import React, { useState } from "react";
import { Box, Button, HStack } from "@chakra-ui/react";
import { SubjectFilterComponentStyles } from "./SubjectFilterComponentStyles";

const SubjectFilterComponent = ({
  subjectList,
  taskData,
  setFilteredTaskData,
  selectedSubject,
  setSelectedSubject,
  setStartTaskIndex,
}) => {
  const subjects = ["All", ...subjectList];

  const handleFilter = (subject) => {
    setSelectedSubject(subject);
    setStartTaskIndex(0);
    if (subject === "All") {
      setFilteredTaskData(taskData);
    } else {
      const filteredData = taskData.filter(
        (task) => task?.taskAttributes?.subjectName === subject
      );
      setFilteredTaskData(filteredData);
    }
  };

  return (
    <Box sx={SubjectFilterComponentStyles()?.mainContainer}>
      {subjects?.map((subject, index) => (
        <Button
          data-testid={`subject-filter-button-${subject}`}
          key={index}
          onClick={() => handleFilter(subject)}
          sx={
            selectedSubject === subject
              ? SubjectFilterComponentStyles()?.activeButton
              : SubjectFilterComponentStyles()?.passiveButton
          }
        >
          {subject}
        </Button>
      ))}
    </Box>
  );
};

export default SubjectFilterComponent;
